<template>
  <ul v-if="data.length > 0">
    <li
      v-for="(t1, i) in data"
      :key="'t_' + num + '_' + i"
      :class="value[num] ? (t1.id == value[num].id ? 'on' : '') : ''"
    >
      <span
        @click="
          value.splice(num, value.length);
          value.push(t1);
        "
        :title="t1.label"
        >{{ t1.label }}
      </span>
      <div>
        <tree
          v-if="value[num]"
          v-model="value"
          :num="num + 1"
          :data="value[num].children"
        ></tree>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "tree",
  props: ["data", "num", "value"],
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/resource/tree.vue